import { Button, Divider, Table, Tooltip } from "antd";
import React, { useState } from 'react';
import { connect, useDispatch } from "react-redux";
import InputSearch from "../../../components/Basic/InputSearch";
import Icon, { ICON_NAME } from "../../../components/Icon";
import Menu from "../../../components/Menu";
import { openPopup } from "../../../components/Popup/_components/WrapperPopup";
import { DiseaseService } from "../../../util/services/disease";
import { AppState } from "../../../util/store/store";
import { IDisease } from "../../../util/varibles/interface";
import { ACTION } from "../../../util/varibles/permission";
import Delete from "../Delete";
import PopupEdit from "../PopupEdit";
import { diseaseActions } from "../reducer";
import styles from "../style.module.scss";
const mapStateToProps = (state: AppState) => ({
    diseases: state.disease.diseases,
    loading: state.disease.loading,
    actions: state.login.user.permission
});

interface IProps {
    diseases: IDisease[]
    loading: boolean
    actions: any
}

const Diseases: React.FC<IProps> = (props) => {
    const { actions, diseases, loading } = props;
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            width: 60,
            render: (data: any) => {
                const list = [];

                if (actions[ACTION.DISEASE.UPDATE]) {
                    list.push({
                        key: 'edit',
                        label: <div className='menu-line' onClick={() => edit(data)}>
                            <Icon icon={ICON_NAME.EDIT} />
                            <div>Edit disease</div>
                        </div>
                    })
                }

                if (actions[ACTION.DISEASE.DELETE]) {
                    list.push({
                        key: 'delete',
                        label: <Delete data={data} onSuccess={() => dispatch(diseaseActions.delete(data))} />
                    })
                }

                return <Menu items={list} placement='bottomRight'>
                    <div className='three-dot' />
                </Menu>
            }
        }
    ]

    const edit = (data?: any) => {
        let action: any, title, okText, request;
        if (data) {
            title = 'Update disease ' + data.name;
            action = diseaseActions.update;
            request = DiseaseService.update
        } else {
            title = 'Add disease';
            okText = 'Add'
            action = diseaseActions.add
            request = DiseaseService.create
        }
        const el = openPopup(<PopupEdit
            open={true}
            data={data}
            title={title}
            okText={okText}
            request={request}
            onOk={(disease) => dispatch(action(disease))}
            onClose={() => el.remove()}
        />)
    }

    return <div className={styles.category}>
        <div className='flex justify-end mb-10'>
            <InputSearch placeHolder='Search by name' value={search}
                onChange={(search) => setSearch(search)} />
            <Divider className='divider-vertical' orientation='vertical' />
            {actions[ACTION.DISEASE.CREATE] && <Tooltip title="Add disease">
                <Button className='bt-primary bt-plus' type="primary" shape="circle"
                    onClick={() => edit()}
                />
            </Tooltip>}
        </div>
        <Table columns={columns} dataSource={diseases} rowKey="id" pagination={false} loading={loading} />
    </div>;
};

export default connect(mapStateToProps, {})(Diseases);